
/*
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#176ED3',
        secondary: '#ee6090',
        defecation: '#02C07C',
        temperature: '#EB2121',
        milk: '#DB069F',
        sleep: '#FF5722',
      },
    },
  },
});
*/

import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css'; // MDIアイコンのCSSをインポート
import { ja as dateJa, vi as dateVi, enUS as dateEn } from 'date-fns/locale';
import DateFnsAdapter from '@date-io/date-fns';
// Vuetify locale translations
import { ja, vi, en } from 'vuetify/locale';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import { useI18n } from 'vue-i18n';
import i18n from './i18n';

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: 'en',
    fallback: 'en',
    messages: { ja, vi, en },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#176ED3',
          secondary: '#ee6090',
          defecation: '#02C07C',
          temperature: '#EB2121',
          milk: '#DB069F',
          sleep: '#FF5722',
        },
      },
    },
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      ja: dateJa,
      vi: dateVi,
      en: dateEn,
    },
  },
});

// Function to update Vuetify locale
export function setVuetifyLocale(locale: string) {
  vuetify.locale.current.value = locale as 'vi' | 'en' | 'ja';
}

export default vuetify;